import {
  ElementsButton,
  PasswordInput,
  SideOverHeading,
  WeakPasswordMessageBox,
  SideOverHeader,
  passwordRegex,
} from '../../UI/components';
import { useUpdatePasswordForm } from '../hooks/useUpdatePasswordForm';

type UpdatePasswordSideOverInnerProps = {
  onUpdateSucess?: () => void;
  onUpdateError?: () => void;
};

export function UpdatePasswordSideOverInner({ onUpdateSucess, onUpdateError }: UpdatePasswordSideOverInnerProps) {
  const {
    tCommon,
    tForm,
    clearErrors,
    register,
    loading,
    handleSubmit,
    failsNewDifferentThanCurrentPassword,
    failsComplexity,
    failsConfrimedSameAsNewPassword,
    passwordIncorrect,
    passwordChangeLimitExceeded,
  } = useUpdatePasswordForm(onUpdateSucess, onUpdateError);

  return (
    <>
      <SideOverHeader />
      <SideOverHeading className="mb-[52px]" heading={tForm('update-password-title')} />

      <form method="post" onSubmit={handleSubmit}>
        <PasswordInput
          className="mt-6"
          status={passwordIncorrect || passwordChangeLimitExceeded ? 'errored' : 'normal'}
          helperText={(() => {
            if (passwordChangeLimitExceeded) return tForm('err-password-change-limit-exceeded');
            else if (passwordIncorrect) return tForm('err-invalid-password-try-again');
            else return '';
          })()}
          label={tForm('password-current')}
          inputProps={{
            autoComplete: 'current-password',
            autoFocus: true,
            required: true,
          }}
          {...register('currentPassword', {
            required: true,
          })}
        />
        <WeakPasswordMessageBox
          offset={[0, 0]}
          placement="bottom-end"
          open={failsComplexity}
          setOpen={(open) => !open && clearErrors('newPassword')}
        >
          <PasswordInput
            className="mt-6"
            label={tForm('password-new')}
            status={failsComplexity || failsNewDifferentThanCurrentPassword ? 'errored' : 'normal'}
            helperText={failsNewDifferentThanCurrentPassword ? tForm('err-invalid-password-same-as-current') : ''}
            inputProps={{
              autoComplete: 'new-password',
              required: true,
            }}
            {...register('newPassword', {
              validate: {
                failsNewDifferentThanCurrent: (newPassword: string, formValues) =>
                  newPassword !== formValues.currentPassword,
                failsComplexity: (newPassword: string) => passwordRegex.test(newPassword),
              },
            })}
          />
        </WeakPasswordMessageBox>
        <PasswordInput
          className="mt-4"
          status={failsConfrimedSameAsNewPassword ? 'errored' : 'normal'}
          helperText={failsConfrimedSameAsNewPassword ? tForm('err-passwords-dont-match') : ''}
          inputProps={{
            required: true,
          }}
          {...register('confirmNewPassword', {
            validate: (confirmPassword: string, formValues) => confirmPassword === formValues.newPassword,
          })}
          label={tForm('password-new-confirm')}
        />
        <ElementsButton
          icon="check"
          iconPosition="left"
          size="large"
          isLoading={loading}
          className="mt-20"
          label={tCommon('save')}
        />
      </form>
    </>
  );
}
